import { type AddToBagSummary, type Context, type SelectedProduct } from '../types';

// ─────────────────────────────────────────────────────────────────────────────

export function getAddToBagSummary(context: Context): AddToBagSummary {
  const { productAdds, selectedProducts } = context;

  const failedProductSlugs = selectedProducts
    .filter((selectedProduct) => productAdds.failed.includes(selectedProduct.selectionId))
    .map(getProductSlug);

  return {
    addedCount: productAdds.added.length,
    failedProductSlugs,
  };
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function getProductSlug(selectedProduct: SelectedProduct) {
  return selectedProduct.productSlug;
}
